(function () {
    'use strict';

    var lightbox = null;
    var lightboxMediaWrap = null;
    var lightboxPrev = null;
    var lightboxNext = null;
    var currentGallery = [];
    var currentIndex = 0;
    var lightboxEventsBound = false;

    function cacheLightboxElements() {
        lightboxMediaWrap = lightbox.querySelector('.mb-lightbox__media-wrap');
        lightboxPrev = lightbox.querySelector('.mb-lightbox__nav--prev');
        lightboxNext = lightbox.querySelector('.mb-lightbox__nav--next');
    }

    function bindLightboxEvents() {
        if (!lightbox || lightboxEventsBound) return;

        lightbox.querySelector('.mb-lightbox__close').addEventListener('click', closeLightbox);
        lightbox.querySelector('.mb-lightbox__backdrop').addEventListener('click', closeLightbox);
        lightboxPrev.addEventListener('click', function () { navigate(-1); });
        lightboxNext.addEventListener('click', function () { navigate(1); });

        document.addEventListener('keydown', function (e) {
            if (!lightbox || lightbox.hidden) return;
            if (e.key === 'Escape') { closeLightbox(); return; }
            if (e.key === 'ArrowLeft') { navigate(-1); return; }
            if (e.key === 'ArrowRight') { navigate(1); }
        });

        lightboxEventsBound = true;
    }

    function buildLightbox() {
        if (document.getElementById('mb-reviews-lightbox')) {
            lightbox = document.getElementById('mb-reviews-lightbox');
            cacheLightboxElements();
            bindLightboxEvents();
            return;
        }

        lightbox = document.createElement('div');
        lightbox.id = 'mb-reviews-lightbox';
        lightbox.className = 'mb-lightbox';
        lightbox.setAttribute('role', 'dialog');
        lightbox.setAttribute('aria-modal', 'true');
        lightbox.setAttribute('aria-label', 'Media viewer');
        lightbox.hidden = true;

        lightbox.innerHTML =
            '<div class="mb-lightbox__backdrop"></div>' +
            '<button class="mb-lightbox__close" aria-label="Close">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
            '<button class="mb-lightbox__nav mb-lightbox__nav--prev" aria-label="Previous">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
            '</button>' +
            '<div class="mb-lightbox__media-wrap"></div>' +
            '<button class="mb-lightbox__nav mb-lightbox__nav--next" aria-label="Next">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
            '</button>' +
            '<div class="mb-lightbox__counter"></div>';

        document.body.appendChild(lightbox);

        cacheLightboxElements();
        bindLightboxEvents();
    }

    function openLightbox(galleryItems, index) {
        buildLightbox();
        currentGallery = galleryItems;
        currentIndex = index;
        renderMedia(currentIndex);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        updateNav();
        lightbox.querySelector('.mb-lightbox__close').focus();
    }

    function closeLightbox() {
        if (!lightbox) return;
        pauseVideos();
        lightbox.hidden = true;
        document.body.style.overflow = '';
        lightboxMediaWrap.innerHTML = '';
    }

    function navigate(dir) {
        var next = currentIndex + dir;
        if (next < 0 || next >= currentGallery.length) return;
        pauseVideos();
        currentIndex = next;
        renderMedia(currentIndex);
        updateNav();
    }

    function pauseVideos() {
        if (!lightboxMediaWrap) return;
        lightboxMediaWrap.querySelectorAll('video').forEach(function (v) { v.pause(); });
    }

    function updateNav() {
        var counter = lightbox.querySelector('.mb-lightbox__counter');
        lightboxPrev.hidden = currentIndex === 0;
        lightboxNext.hidden = currentIndex === currentGallery.length - 1;
        if (currentGallery.length > 1) {
            counter.textContent = (currentIndex + 1) + ' / ' + currentGallery.length;
        } else {
            counter.textContent = '';
        }
    }

    function renderMedia(index) {
        var item = currentGallery[index];
        lightboxMediaWrap.innerHTML = '';

        if (item.dataset.lightboxType === 'video') {
            var origVideo = item.querySelector('video');
            if (origVideo) {
                var video = origVideo.cloneNode(true);
                video.controls = true;
                video.autoplay = false;
                video.removeAttribute('autoplay');
                video.className = 'mb-lightbox__video';
                lightboxMediaWrap.appendChild(video);
            }
        } else {
            var img = document.createElement('img');
            img.src = item.dataset.lightboxSrc || (item.querySelector('img') ? item.querySelector('img').src : '');
            img.alt = item.querySelector('img') ? (item.querySelector('img').alt || '') : '';
            img.className = 'mb-lightbox__image';
            lightboxMediaWrap.appendChild(img);
        }
    }

    function initGallery(galleryEl) {
        var items = Array.from(galleryEl.querySelectorAll('.mb-review-card__gallery-item'));
        if (!items.length) return;
        items.forEach(function (item, index) {
            item.setAttribute('role', 'button');
            item.setAttribute('tabindex', '0');
            item.setAttribute('aria-label', item.dataset.lightboxType === 'video' ? 'Play video' : 'View image');
            item.addEventListener('click', function () { openLightbox(items, index); });
            item.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openLightbox(items, index);
                }
            });
        });
    }

    function init() {
        document.querySelectorAll('.mb-review-card__gallery').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
